import { render, staticRenderFns } from "./TagEmailAutomationLogs.vue?vue&type=template&id=20e4a649&scoped=true&"
import script from "./TagEmailAutomationLogs.vue?vue&type=script&lang=js&"
export * from "./TagEmailAutomationLogs.vue?vue&type=script&lang=js&"
import style0 from "./TagEmailAutomationLogs.vue?vue&type=style&index=0&id=20e4a649&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e4a649",
  null
  
)

export default component.exports